import {
  ArrowTrendingUpIcon,
  SparklesIcon,
  WrenchIcon,
} from "@heroicons/react/24/outline"
import {
  FeatureAnnouncementCategory,
  IFeatureAnnouncement,
} from "services/featureAnnouncementsService"

type CategoryMeta = {
  label: string
  /** Tab label. */
  plural: string
  Icon: typeof SparklesIcon
  /** Icon tile: tint, border and icon colour. */
  tile: string
  /** Type chip on rows, the featured card and the drawer. */
  chip: string
}

export const CATEGORY_ORDER: FeatureAnnouncementCategory[] = [
  "feature",
  "improvement",
  "fix",
]

export const CATEGORY_META: Record<FeatureAnnouncementCategory, CategoryMeta> =
  {
    feature: {
      label: "Feature",
      plural: "Features",
      Icon: SparklesIcon,
      tile: "border-primary100 bg-primary50 text-primary500",
      chip: "border-primary200 bg-primary50 text-primary600",
    },
    improvement: {
      label: "Improvement",
      plural: "Improvements",
      Icon: ArrowTrendingUpIcon,
      tile: "border-[#CDEFD9] bg-[#ECFAF1] text-[#178045]",
      chip: "border-[#BFE6CC] bg-[#ECFAF1] text-[#178045]",
    },
    fix: {
      label: "Fix",
      plural: "Fixes",
      Icon: WrenchIcon,
      tile: "border-[#FBE2C2] bg-[#FFF6EA] text-[#C25E0B]",
      chip: "border-[#F7D3A6] bg-[#FFF6EA] text-[#B45309]",
    },
  }

/** Until announcements carry a category, every one looks like a feature (blue, sparkles). */
export const metaFor = (item: IFeatureAnnouncement) =>
  CATEGORY_META[item.category ?? "feature"] ?? CATEGORY_META.feature

export const CategoryTile = ({
  item,
  className = "",
  iconClassName = "h-1/2 w-1/2",
}: {
  item: IFeatureAnnouncement
  className?: string
  iconClassName?: string
}) => {
  const { Icon, tile } = metaFor(item)
  return (
    <span
      className={`flex shrink-0 items-center justify-center border ${tile} ${className}`}
    >
      <Icon className={`stroke-[1.8] ${iconClassName}`} />
    </span>
  )
}

/** Hidden until the item has a category, so no announcement is mislabelled. */
export const CategoryChip = ({ item }: { item: IFeatureAnnouncement }) => {
  if (!item.category || !CATEGORY_META[item.category]) return null
  const { label, chip } = CATEGORY_META[item.category]
  return (
    <span
      className={`inline-flex h-6 items-center rounded-full border px-2.5 text-xs font-semibold ${chip}`}
    >
      {label}
    </span>
  )
}

export const NewPill = () => (
  <span className="inline-flex h-5 items-center rounded-full bg-primary500 px-2 text-[11px] font-semibold text-a11y">
    New
  </span>
)
